import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Radio } from 'antd';

import useGlobalConfig from '@/store/global';

const RequestOptionPage = () => {
  const navigate = useNavigate();
  const { themeColor } = useGlobalConfig();
  const [option, setOption] = useState('');
  const plainOptions = [
    { label: 'I have a claim form.', value: 'claim' },
    { label: 'I want to submit a request for copay assistance.', value: 'request' },
  ];

  const onChange = (e: any) => {
    setOption(e.target.value);
  };

  return (
    <div className="min-h-[50vh] px-20">
      <div className="flex justify-end">
        <Button className="mr-5" onClick={() => navigate(-1)}>
          Back
        </Button>
        <Button
          type="primary"
          disabled={option === ''}
          style={{
            backgroundColor: option === '' ? themeColor + '90' : themeColor,
            color: 'white',
          }}
          onClick={() =>
            navigate(
              option === 'claim' ? '/assistance_requests/by-upload' : '/assistance_requests/new'
            )
          }
        >
          Proceed
        </Button>
      </div>
      <div className="mt-5">
        <div className="text-base font-semibold">Please select the option that applies to you</div>

        <div className="mt-5 flex flex-col gap-4">
          <Radio.Group onChange={onChange} value={option}>
            {plainOptions.map((item) => (
              <div className="px-5 py-4 flex justify-between items-center bg-zinc-100 my-4 text-base rounded">
                <Radio value={item.value}>
                  <span className="ml-4 text-base font-semibold">{item.label}</span>
                </Radio>
              </div>
            ))}
          </Radio.Group>
        </div>
      </div>
    </div>
  );
};

export default RequestOptionPage;
